import {
  useOrganization,
  useOrganizationDevicesSort,
  useUpdateOrganizationDevicesSort,
} from '../../../../../../features/organization';
import { Sort } from '../../../../sort';
import { IDevicesSortProps } from './types';

export const DevicesSort = ({ by }: IDevicesSortProps) => {
  const updateSort = useUpdateOrganizationDevicesSort();
  const {
    status: { fetchDevices: status },
  } = useOrganization();
  const sort = useOrganizationDevicesSort();

  return (
    <Sort baseTranslationKey="organization.devices.table" by={by} sort={sort} status={status} updateSort={updateSort} />
  );
};
